/*
 * TurnCancellationButton Messages
 *
 * This contains all the text for the TurnCancellationButton component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelShift: {
    id: 'app.components.TurnCancellationButton.cancelShift',
    defaultMessage: 'Cancel shift',
  },
  confirmCancellationTitle: {
    id: 'app.components.TurnCancellationButton.confirmCancellationTitle',
    defaultMessage: 'Cancel shift',
  },
  cancellationLabel: {
    id: 'app.components.TurnCancellationButton.cancellationLabel',
    defaultMessage: 'Reason',
  },
  confirmCancellation: {
    id: 'app.components.TurnCancellationButton.confirmCancellation',
    defaultMessage: 'Cancel shift',
  },
  cancelCancellation: {
    id: 'app.components.TurnCancellationButton.cancelCancellation',
    defaultMessage: "Don't cancel shift",
  },
  cancellationSuccess: {
    id: 'app.components.TurnCancellationButton.cancellationSuccess',
    defaultMessage: 'Turn cancelled successfully.',
  },
  cancellationFailure: {
    id: 'app.components.TurnCancellationButton.cancellationFailure',
    defaultMessage: 'Error. Cancelling the turn failed.',
  },
});
